module.exports = __webpack_public_path__ + "static/media/cauliflower.a54d57e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svgs/ingredients/cauliflower.svg
// module id = 721
// module chunks = 0